import { render, staticRenderFns } from "./suitable.vue?vue&type=template&id=1bda8ebf"
import script from "./suitable.vue?vue&type=script&lang=js"
export * from "./suitable.vue?vue&type=script&lang=js"
import style0 from "./suitable.vue?vue&type=style&index=0&id=1bda8ebf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports